/**
 * What the assistant is called on screen. It is the signed-in user's own assistant rather than a
 * named persona, so the name is derived from them and there is one place that derives it — the
 * header, every answer block and the waiting block all have to agree.
 */
export const assistantDisplayName = (user) => (user?.name ? `${user.name}'s Assistant` : "Your Assistant");
